import { render, staticRenderFns } from "./TrainConfigLastUpdatedCell.vue?vue&type=template&id=4025bea5&scoped=true"
import script from "./TrainConfigLastUpdatedCell.vue?vue&type=script&lang=js"
export * from "./TrainConfigLastUpdatedCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4025bea5",
  null
  
)

export default component.exports